module.exports = __webpack_public_path__ + "static/media/manat.9e7733a6.svg";